var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-loading"},[_c('b-spinner',{style:(_vm.spinnerStyle),attrs:{"variant":"primary"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }